module.exports = __webpack_public_path__ + "static/media/2.afb310eb.jpg";